// extracted by mini-css-extract-plugin
export default {"infoBtn":"GameInfoBtn__infoBtn--I-F","icon":"GameInfoBtn__icon--lb7"};